<template>
    <el-dialog :visible.sync="show"
        :title="$t('operations.turnOffDeleteProtect.name')"
        :close-on-click-modal="false"
        :before-close="handleClose"
        width="30%"
        class="del-root">
        <p>{{ $t('privateNetInstance.turnOffDeleteProtectTip', [instanceName]) }}</p>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handlecCancel">{{ $t('privateNetInstance.cancel') }}</el-button>
            <el-button @click="handleSure" type="primary">{{ $t('privateNetInstance.sure') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'DisableDeletionProtection',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        instanceName: {
            type: String,
            default: ''
        },
        instanceId: {
            type: String,
            default: ''
        },
        region: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            show: false
        };
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
        }
    },
    methods: {
        handleClose() {
            this.show = false;
            this.$emit('update:visible', false);
        },
        handlecCancel() {
            this.handleClose();
        },
        handleSure() {
            const params = {
                region: this.region,
                instanceId: this.instanceId,
                removeProtect: "no"
            };
            Ajax.post('/api/cps/modifyInstanceRemoveProtect', params)
            .then((res) => {
                this.$message.success(this.$t('privateNetInstance.operateSuccess'));
            })
            .catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.handleClose();
                this.$emit('refresh');
            });
        }
    },
};
</script>

<style scoped lang="scss">
    .del-root {
        p {
            text-align: left;
            margin: 12px;
            line-height: 1.5;
            color: #212121;
            word-break: break-all;
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/disableDeletionProtection/DisableDeletionProtection.vue